export const csvTasks = [
  'createUser',
  'updateUser',
  'userEnrollment',
  'curriculaVisibility',
] as const

export type CSVTask = (typeof csvTasks)[number]

export const csvTaskLabels: Record<CSVTask, string> = {
  createUser: 'Create User',
  updateUser: 'Update User',
  userEnrollment: 'User Enrollment',
  curriculaVisibility: 'Curricula Visibility',
}

export const defaultUploadPathByTask: Record<CSVTask, string> = {
  createUser: '/v1/kat/users/csv/create',
  updateUser: '/v1/kat/users/csv/update',
  userEnrollment: '/v1/kat/classes/csv/enrollment',
  curriculaVisibility: '/v1/kat/users/csv/curriculaVisibility',
}

export const csvUploadText = {
  openButtonLabel: 'CSV Bulk Operations',
  dialogTitle: 'CSV Upload',
  taskLabel: 'CSV Task',
  taskPlaceholder: 'Select CSV Task',
  addRolesLabel: 'Add roles',
  columnsUnavailable: 'Columns not available',
  selectTaskToViewColumns: 'Select a task to view columns',
  helperText: 'Upload a CSV file for processing.',
  uploadButtonLabel: 'Upload CSV',
  downloadTemplateButtonLabel: 'Download Template',
  cancelButtonLabel: 'Cancel',
} as const
